import React, { useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { EmptyState, InlineLoader } from "@/components/shared";
import { Input } from "@/components/ui/input";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import { ScrollText, Search } from "lucide-react";

export default function AuditLog() {
  const [logs, setLogs] = useState(null);
  const [q, setQ] = useState("");
  const [query, setQuery] = useState("");

  useEffect(() => {
    setLogs(null);
    api.get("/admin/audit-logs", { params: { q: query || undefined } })
      .then((r) => setLogs(r.data)).catch(() => setLogs([]));
  }, [query]);

  return (
    <div>
      <div className="mb-6">
        <h1 className="font-heading text-2xl font-extrabold tracking-tight text-ff-blue sm:text-3xl">Audit Log</h1>
        <p className="mt-1 text-sm text-ff-medium">Every admin action is recorded for accountability.</p>
      </div>

      <form onSubmit={(e) => { e.preventDefault(); setQuery(q); }} className="mb-5 flex max-w-md gap-2">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-ff-medium" />
          <Input data-testid="audit-search" value={q} onChange={(e) => setQ(e.target.value)}
            placeholder="Search actions, entity type, id…" className="pl-9" />
        </div>
      </form>

      {logs === null ? (
        <InlineLoader label="Loading audit log" />
      ) : logs.length === 0 ? (
        <EmptyState icon={ScrollText} title="No audit entries" message="Admin actions will appear here." testid="audit-empty" />
      ) : (
        <div className="overflow-hidden rounded-xl border border-ff-border bg-white shadow-sm" data-testid="audit-table">
          <Table>
            <TableHeader>
              <TableRow className="bg-[#F3F4F6]">
                <TableHead>Action</TableHead>
                <TableHead>Entity</TableHead>
                <TableHead>Entity ID</TableHead>
                <TableHead>Details</TableHead>
                <TableHead className="text-right">When</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {logs.map((l) => (
                <TableRow key={l.id} data-testid={`audit-row-${l.id}`}>
                  <TableCell><span className="font-semibold text-ff-blue">{l.action}</span></TableCell>
                  <TableCell className="text-ff-dark">{l.entity_type}</TableCell>
                  <TableCell className="font-mono text-xs text-ff-medium">{String(l.entity_id).slice(-8)}</TableCell>
                  <TableCell className="max-w-xs truncate text-xs text-ff-dark">{l.details?.notes || JSON.stringify(l.details || {})}</TableCell>
                  <TableCell className="text-right text-xs text-ff-medium">{new Date(l.created_at).toLocaleString()}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  );
}
